document.addEventListener('DOMContentLoaded', function(){
  var toggle = document.querySelector('.bn-mobile-toggle');
  var nav = document.querySelector('#BNMainNav');
  if(toggle && nav){
    toggle.addEventListener('click', function(){
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
  var els = document.querySelectorAll('.bn-fade');
  if('IntersectionObserver' in window){
    var observer = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){ if(entry.isIntersecting){ entry.target.classList.add('bn-visible'); observer.unobserve(entry.target); } });
    }, {threshold:.12});
    els.forEach(function(el){ observer.observe(el); });
  } else { els.forEach(function(el){ el.classList.add('bn-visible'); }); }
});


(function () {
  function routeNameFromPath(path) {
    path = (path || '').toLowerCase();
    if (path.indexOf('/pages/fish-feed') !== -1) return 'fish-feed';
    if (path.indexOf('/pages/prawn-feed-feed') !== -1) return 'prawn-feed';
    if (path.indexOf('/pages/bulk-supply') !== -1 || path.indexOf('/pages/products') !== -1) return 'bulk-supply';
    if (path.indexOf('/pages/de-heus') !== -1 || path.indexOf('/pages/deheus') !== -1) return 'de-heus';
    if (path.indexOf('/pages/about') !== -1) return 'about';
    if (path.indexOf('/pages/contact') !== -1) return 'contact';
    return '';
  }

  function revealRoutedPage() {
    var body = document.body;
    if (!body) return;

    var is404 = body.classList.contains('template-404');
    var isDefaultPage = body.classList.contains('template-page') && !(
      body.classList.contains('template-suffix-fish-feed') ||
      body.classList.contains('template-suffix-prawn-feed') ||
      body.classList.contains('template-suffix-bulk-supply') ||
      body.classList.contains('template-suffix-products') ||
      body.classList.contains('template-suffix-de-heus') ||
      body.classList.contains('template-suffix-about') ||
      body.classList.contains('template-suffix-contact')
    );

    if (!is404 && !isDefaultPage) return;

    var route = routeNameFromPath(window.location.pathname);
    var routed = document.querySelectorAll('.bn-routed-page');
    var fallback = document.querySelector('.bn-placeholder-route');

    routed.forEach(function (el) { el.classList.remove('bn-route-active'); });
    if (fallback) fallback.classList.remove('bn-route-active');

    var target = route ? document.querySelector('.bn-routed-page[data-bn-route="' + route + '"]') : null;
    if (target) {
      target.classList.add('bn-route-active');
      document.title = target.querySelector('h1') ? target.querySelector('h1').textContent + ' – Big Nutrition' : document.title;
    } else if (fallback) {
      fallback.classList.add('bn-route-active');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', revealRoutedPage);
  } else {
    revealRoutedPage();
  }
})();
